module.exports = __webpack_public_path__ + "static/Graphik-Light-Web-0ef4aa6497bac19671aa229eaae20a79.woff2";